import { useEffect, useMemo, useState } from 'react';
import './App.css';
import { PolicyDocument } from './PolicyDocument';
import { pages } from './policyContent';

const routes = {
  '/privacy-policy': 'privacy',
  '/terms-and-conditions': 'terms',
};

function getPageKey(pathname) {
  return routes[pathname] || 'privacy';
}

function App() {
  const [pathname, setPathname] = useState(window.location.pathname);
  const pageKey = getPageKey(pathname);
  const page = pages[pageKey];

  const navItems = useMemo(
    () => [
      { label: 'Privacy Policy', path: '/privacy-policy', key: 'privacy' },
      { label: 'Terms & Conditions', path: '/terms-and-conditions', key: 'terms' },
    ],
    []
  );

  useEffect(() => {
    const syncPath = () => setPathname(window.location.pathname);

    window.addEventListener('popstate', syncPath);
    return () => window.removeEventListener('popstate', syncPath);
  }, []);

  useEffect(() => {
    document.title = `${page.title} | UNITED AUTOSPORTS TRACKSIDE APP`;
  }, [page.title]);

  function navigate(event, path) {
    event.preventDefault();
    window.history.pushState({}, '', path);
    setPathname(window.location.pathname);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  return (
    <>
      <header className="site-header">
        <div className="container header-content">
          <a
            className="brand"
            href="/privacy-policy"
            onClick={(event) => navigate(event, '/privacy-policy')}
            aria-label="Trackside home"
          >
            <img
              className="brand-logo"
              src={`${process.env.PUBLIC_URL}/logo-primary.svg`}
              alt="United Autosports"
            />
          </a>

          <nav className="site-nav" aria-label="Policy pages">
            {navItems.map((item) => (
              <a
                key={item.key}
                href={item.path}
                className={item.key === pageKey ? 'active' : undefined}
                aria-current={item.key === pageKey ? 'page' : undefined}
                onClick={(event) => navigate(event, item.path)}
              >
                {item.label}
              </a>
            ))}
          </nav>
        </div>
      </header>

      <main className="container page-shell">
        <article className="policy-card">
          <PolicyDocument document={page} />
        </article>
      </main>

      <footer className="site-footer">
        <div className="container">
          <p>© {new Date().getFullYear()} UNITED AUTOSPORTS TRACKSIDE APP. All rights reserved.</p>
        </div>
      </footer>
    </>
  );
}

export default App;
